import { Iconify } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import React from "react";

const BooleanIconCellComponent = ({
    value,
    width = 20,
    activeIcon = "dashicons:yes",
    inactiveIcon = "material-symbols:close-rounded",
    activeClass = "active",
    inactiveClass = "inactive",
    activeTooltip = "",
    inactiveTooltip = ""
}) => {
    const isActive = Boolean(value);

    return (
        <Iconify icon={isActive ? activeIcon : inactiveIcon} width={width}
            className={isActive ? activeClass : inactiveClass}
            ttLabel={isActive ? activeTooltip : inactiveTooltip}
            targetId={(isActive ? activeTooltip : inactiveTooltip)?.replace(/\s+/g, '').toLowerCase()}
        />
    );
};

BooleanIconCellComponent.propTypes = {
    value: PropTypes.any,
    width: PropTypes.number,
    activeIcon: PropTypes.string,
    inactiveIcon: PropTypes.string,
    activeClass: PropTypes.string,
    inactiveClass: PropTypes.string,
    activeTooltip: PropTypes.string,
    inactiveTooltip: PropTypes.string
};

export const BooleanIconCell = React.memo(BooleanIconCellComponent);